// extracted by mini-css-extract-plugin
export default {"AppContainer":"App_AppContainer__wJ7qa"};